import { Vehicle } from "../Interfaces/vehicle.type";

const getSectionType = (vehicle: Vehicle, degradedServices: string[]) => {
  const invoiceIsPaid = vehicle?.invoice?.invoicePaid === true;
  const invoiceGenerating = vehicle.paymentStatus === "NoInvoice";
  const paymentFailed = vehicle.paymentStatus === "Failed";
  const paymentDue = vehicle.paymentStatus === "InvoiceNotPaid";
  const paymentProcessing = vehicle?.paymentStatus === "Processing";
  const isPartnerFinance =
    vehicle.paymentStatus === "PartnerFinanceInvoice" ||
    vehicle.paymentStatus === "PartnerFinanceProcessing" ||
    vehicle.paymentStatus === "PartnerFinanceFailed";

  const invoicePaid = vehicle?.paymentStatus === "InvoicePaid";

  const invoiceIsReady =
    vehicle?.invoice?.invoicePaid === false &&
    vehicle?.invoice.canPayInvoice === true;
  const invoiceIsNotReady =
    vehicle?.invoice?.invoicePaid === false &&
    vehicle?.invoice?.canPayInvoice === false;

  const isEligibleForDelivery = vehicle.isEligibleForDelivery;
  const hasDeliveryBooked = vehicle.isOrderReferenceAdded === true;
  const hasDeliveryCancelled = vehicle?.orderState?.status === "Cancelled";
  const isExport = vehicle?.isExport === true;
  const hasCollectionBooked = vehicle.isBookedForCollection === true;
  const hasTransportBooked = hasDeliveryBooked || hasCollectionBooked;
  const isVehicleOffsited = vehicle.isVehicleOffsited;

  const invoiceServiceDegraded = degradedServices?.includes("InvoiceService");
  const deliveryServiceDegraded = degradedServices?.includes("DeliveryService");
  const collectionsServiceDegraded =
    degradedServices?.includes("CollectionService");

  if (!isPartnerFinance && !invoiceServiceDegraded) {
    if (isExport) {
      if (invoicePaid) {
        if (deliveryServiceDegraded) {
          return "exportedDeliveriesDegraded";
        }
        return "exported";
      }
      if (deliveryServiceDegraded) {
        return "exportDeliveriesDegraded";
      }
      return "export";
    }
    if (invoiceIsReady && !hasTransportBooked) {
      if (paymentFailed) {
        if (hasDeliveryCancelled) {
          return "paymentFailedDeliveryCancelled";
        }
        if (!isEligibleForDelivery) {
          return "paymentFailedNoTransportBookedNotEligibleForDelivery";
        }
        return "paymentFailedNoTransportBooked";
      }
      if (!isEligibleForDelivery) {
        return "invoiceReadyNoTransportBookedNotEligibleForDelivery";
      }
      if (hasDeliveryCancelled) {
        return "invoiceReadyDeliveryCancelled";
      }
      return "invoiceReadyNoTransportBooked";
    }
    if (paymentProcessing && !hasTransportBooked) {
      return "paymentProcessingNoTransportBooked";
    }
    if (invoiceIsPaid && !hasTransportBooked) {
      if (isVehicleOffsited) {
        return "invoicePaidNoTransportBookedIsOffsiteTrue";
      }
      return "invoicePaidNoTransportBooked";
    }
    if (invoiceIsPaid && hasCollectionBooked) {
      if (collectionsServiceDegraded) {
        return "invoicePaidCollectionBookedCollectionsDegraded";
      }
      return "invoicePaidCollectionBooked";
    }
    if (paymentFailed && hasDeliveryBooked) {
      if (deliveryServiceDegraded) {
        return "paymentFailedDeliveryBookedDeliveriesDegraded";
      }
      return "paymentFailedDeliveryBooked";
    }
    if (invoiceIsReady && hasDeliveryBooked) {
      if (deliveryServiceDegraded) {
        return "invoiceReadyDeliveryBookedDeliveriesDegraded";
      }
      return "invoiceReadyDeliveryBooked";
    }
    if (paymentProcessing && hasDeliveryBooked) {
      if (deliveryServiceDegraded) {
        return "paymentProcessingDeliveryBookedDeliveriesDegraded";
      }
      return "paymentProcessingDeliveryBooked";
    }
    if (invoiceIsPaid && hasDeliveryBooked) {
      if (deliveryServiceDegraded) {
        return "invoicePaidDeliveryBookedDeliveriesDegraded";
      }
      return "invoicePaidDeliveryBooked";
    }
    if (invoiceGenerating && !hasTransportBooked) {
      return "invoiceGeneratingNoTransportBooked";
    }
    if (
      (invoiceGenerating && hasDeliveryBooked) ||
      (paymentDue && invoiceIsNotReady && hasDeliveryBooked) ||
      (paymentFailed && invoiceIsNotReady && hasDeliveryBooked)
    ) {
      if (deliveryServiceDegraded) {
        return "invoiceGeneratingDeliveryBookedDeliveriesDegraded";
      }
      return "invoiceGeneratingDeliveryBooked";
    }
  }
  if (isPartnerFinance) {
    if (
      vehicle.paymentStatus === "PartnerFinanceProcessing" ||
      vehicle.paymentStatus === "PartnerFinanceFailed"
    ) {
      return vehicle.paymentStatus;
    } else if (!hasTransportBooked) {
      if (isVehicleOffsited) {
        return "partnerFinanceInvoiceNoTransportBookedIsOffsiteTrue";
      }
      return "partnerFinanceInvoiceNoTransportBooked";
    }
  }
  return "noInvoice";
};

export default getSectionType;
